import { Timestamp } from 'rxjs';
import {
  Gender,
  UserRole,
  BringLieselRole,
  UserType,
  PositionInFacility,
} from '../../core/types/enums';
import { JsonProperty } from '../../core/services/utils/mapping.service';

export interface NewStorageUser {
  id: string;
  name: string;
  surname: string;
  email: string;
  role: UserRole;
  color?: string;
  image?: string;
  customerIds: number[];
  newShopLoginDates: string[];
}

export class StorageUser {
  id: string;
  name: string;
  surname: string;
  email: string;
  role: UserRole;
  color?: string;
  image?: string;
  customerIds: number[];
  newShopLoginDates: string[];

  constructor(user: NewStorageUser) {
    this.id = user.id;
    this.name = user.name;
    this.surname = user.surname;
    this.email = user.email;
    this.role = user.role;
    this.color = user.color;
    this.image = user.image;
    this.customerIds = user.customerIds;
    this.newShopLoginDates = user.newShopLoginDates;
  }

  getName(): string {
    return `${this.name} ${this.surname}`;
  }

  get isDomainUser() {
    const domainRegex = new RegExp(
      `@(${['bringliesel', 'euvic'].join('|')})\\.`
    );
    return domainRegex.test(this.email);
  }
}

class UserCustomer {
  @JsonProperty('id')
  id: number = 0;
  @JsonProperty('lastLogin')
  lastLogin: string | null = null;
}

export interface NewUser {
  customerIds: number[];
  customers: UserCustomer[];
  email: string;
  gender: Gender;
  name: string;
  surname: string;
  username: string;
  positionInFacility: string | null;
  password: string;
  role: UserRole;
  type?: UserType;
  phone: string;
  color?: string;
}

export class User {
  @JsonProperty('id')
  id: string = '';
  @JsonProperty('customerIds')
  customerIds: number[] = [];
  @JsonProperty({ clazz: UserCustomer, name: 'customers' })
  customers: Array<UserCustomer> = [];
  @JsonProperty('email')
  email: string = '';
  @JsonProperty('blockedUntil')
  blockedUntil: string = '';
  @JsonProperty('failedLoginsCount')
  failedLoginsCount: number = 0;
  @JsonProperty('gender')
  gender: Gender = Gender.Male;
  @JsonProperty('name')
  name: string = '';
  @JsonProperty('newShopLastLogin')
  newShopLastLogin: Date = undefined;
  @JsonProperty('surname')
  surname: string = '';
  @JsonProperty('username')
  username: string = '';
  @JsonProperty('password')
  password: string = '';
  @JsonProperty('role')
  role: UserRole = UserRole.User;
  @JsonProperty('blRole')
  blRole: Array<BringLieselRole> = [];
  @JsonProperty('type')
  type: UserType = UserType.Customer;
  @JsonProperty('positionInFacility')
  positionInFacility: PositionInFacility = PositionInFacility.Administration;
  @JsonProperty('phone')
  phone: string = '';
  @JsonProperty('color')
  color: string = '';
  @JsonProperty('image')
  image: string = '';
  @JsonProperty('newShopLoginDates')
  newShopLoginDates: string[] = [];
  provider?: string = '';

  constructor(init?: Omit<Partial<User>, 'image'>) {
    Object.assign(this, init);
  }

  getName(): string {
    return `${this.name} ${this.surname}`;
  }
}
